export default __webpack_public_path__ + "static/media/lon~bfJXqVfC.17f91e99.svg";